import UmbrellaList from "./UmbrellaListStatamic";
import {UmbrellaIcon} from "../icons/icons";
import UmbrellaShow from "./UmbrellaShowStatamic";
import {UmbrellaCreateStatamic as UmbrellaCreate, UmbrellaEditStatamic as UmbrellaEdit} from "./UmbrellaEditStatamic";
import {UmbrellaOwnList, UmbrellaOwnShow} from "./UmbrellaOwnStatamic";

const UmbrellaResource = {
    options: { label: 'Umbrella' },
    icon: UmbrellaIcon,
    name: 'umbrellas',
    list: UmbrellaList,
    show: UmbrellaShow,
    edit: UmbrellaEdit,
    create: UmbrellaCreate,
};

// The umbrella admin's own umbrella: no edit or create, only the Notifications card.
export const UmbrellaOwnResource = {
    options: { label: 'Umbrella' },
    icon: UmbrellaIcon,
    name: 'umbrellas',
    list: UmbrellaOwnList,
    show: UmbrellaOwnShow,
};

export default UmbrellaResource;
